var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBevzTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 32,
    viewBox: "0 0 65 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5.74991C8.14924 0 9.77916 0.546786 10.641 1.63936C11.5056 2.72889 11.9495 4.56964 11.9744 7.1626V7.85308C11.9744 9.72283 11.798 11.1935 11.4475 12.2645C11.0994 13.3372 10.4724 14.1147 9.56564 14.5994C11.5187 15.3941 12.4963 17.9436 12.4963 22.2471V22.9167C12.4608 26.0999 11.9798 28.3822 11.0522 29.7629C10.1246 31.1438 8.51422 31.8343 6.22418 31.8343H0V0ZM8.7382 21.7043C8.7382 19.6568 8.56718 18.2232 8.22716 17.4035C7.88984 16.5812 7.22702 16.1703 6.24037 16.1703H3.74186V28.8143H6.03966C7.10053 28.8143 7.81597 28.3977 8.185 27.5652C8.55402 26.7324 8.7382 25.1487 8.7382 22.8111V21.7043ZM8.26393 7.22061V7.10997C8.26393 4.98859 7.89626 3.7341 7.16226 3.34686C6.79998 3.15459 6.27444 3.05677 5.58665 3.05677H3.74153V13.2977H5.86055C6.58409 13.2977 7.09918 13.1803 7.40479 12.9445C7.71309 12.7101 7.93336 12.2423 8.06357 11.5427C8.19681 10.8444 8.26393 9.69787 8.26393 8.10607V7.22061Z",
    fill: "#1E315E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9281 0H26.4414V3.11479H20.675V13.9987H26.1355V17.1135H20.675V28.7246H26.515V31.8343H16.9277L16.9281 0Z",
    fill: "#1E315E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3109 0H43.8423L39.0092 31.8343H34.6504L29.3535 0H32.9163L35.0299 13.4768L36.843 25.3251H36.9114L38.4874 13.4768L40.3109 0Z",
    fill: "#1E315E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6 0H57.4398V2.8618L50.8729 28.7246H57.2921V31.8343H47.0039V28.5981L53.5661 3.11479H47.5996L47.6 0Z",
    fill: "#1E315E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8359 28.2559H64.9983V31.8345H61.8359V28.2559Z",
    fill: "#DAA332"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBevzTextLogo);
export default __webpack_public_path__ + "static/media/bevzTextLogo.3323bf97bb403db10f17d9eeb36d94be.svg";
export { ForwardRef as ReactComponent };